import {createContext} from 'react'

export const AvailableDatesContext = createContext({});
export const LocationsContext = createContext({});
